import script from "./ChatCreateDialogPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatCreateDialogPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatCreateDialogPanel.vue?vue&type=style&index=0&id=0d9a2e31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9a2e31"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
